import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import NavigateButtonPrun from 'components/NavigationButtonPrun'

import SpeedImg from 'assets/img/speed/speed.png'
import ProductBg from 'assets/img/cps/list_bg.png'

import VollyballBg from 'assets/img/cps/vollyball_img.png'
import BasketballBg from 'assets/img/cps/basketball_img.png'
import SoccerBg from 'assets/img/cps/soccer_img.png'
import EtcBg from 'assets/img/cps/etc_img.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'
import NavigateButtonCps from 'components/NavigationButtonCps'

const Container = styled.div`
	background-image: url(${ProductBg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`

const HorizontalScroll = styled.ul`
	display: flex;
	justify-content: center;
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;
	position: absolute;
	top: 336px;
	left: 0;
	right: 0;
	list-style: none;
	padding: 0;
	margin: 0;
	-webkit-overflow-scrolling: touch;
	&::-webkit-scrollbar {
		display: none;
	}
	&.flexStart {
		justify-content: flex-start;
	}
	li {
		width: 404px;
		height: 526px;
		margin-right: 30px;
		margin-left: 30px;
		button {
			border: 0;
			outline: 0;
			background: transparent;
			width: 386px;
			height: 475px;
		}
	}
`
const HorizontalScrollAfter = styled.div`
	display: block;
	width: 100px;
	height: 475px;
	position: absolute;
	top: 336px;
	right: 0;
	opacity: 0.8;
	background: linear-gradient(
		to right,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.7) 100%
	);
`

const CenterBackground = styled.div<{ bgImage: string }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	// location.state?.item?.title 값에 따라 background 이미지 변경
	// 테니스일 경우 VollyballBg, 인도어 스포츠일 경우 VollyballBg, 농구일 경우 BasketballBg, 축구일 경우 SoccerBg, 그 외의 경우 EtcBg
	background-image: url(${({ bgImage }) => bgImage});
	background-repeat: no-repeat;
	background-position: center;
	width: 100%;
	height: 100%;
	z-index: 0;
`

const PageTitle = styled.div`
	position: absolute;
	top: 65px;
	left: 91px;
	font-size: 46px;
	color: #565858;
	min-width: 210px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 200px;
		height: 10px;
		background: #acc7d8;
		margin: 15px auto;
	}
	span {
		font-size: 50px;
	}
`

const CpsList2026 = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [productList, setProductList] = useState<any[]>([])
	const [sateItemInfo, setSateItemInfo] = useState<any>(location.state?.item)

	const getCenterBackgroundImage = (title?: string) => {
		switch (title) {
			case '테니스':
			case '인도어 스포츠':
				return VollyballBg
			case '농구':
				return BasketballBg
			case '축구':
				return SoccerBg
			default:
				return EtcBg
		}
	}

	const menuMove1 = useSpring({
		from: { opacity: 0, x: 100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove = useSpring({
		from: { opacity: 0, y: -100 },
		to: { opacity: 1, y: 0 },
		delay: 0,
	})

	const onTouchEnd = (e: any) => {
		console.log(e)
		console.log(location.state?.item?.subsortId)
		const params = {
			subsortId: location.state?.item?.subsortId,
			productId: e.productId,
			fildId: e.fileId,
			name: e.name,
			subPageTItle: sateItemInfo?.engTitle,
		}

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: e.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		console.table(params)

		navigate(`/cps/view`, {
			state: { item: params },
		})
	}

	useEffect(() => {
		console.log(location.state?.item)
		console.log(location.state?.item?.title)
		if (!location.state?.item) {
			timerAlert('잘못된 접근입니다.', 'error', () => navigate('/'))
		}
		const request = {
			subsortId: location.state?.item?.subsortId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
		}
		apiThumbnailList(request).then((res) => {
			console.log(res)
			setProductList(res)
		})
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			<CenterBackground bgImage={getCenterBackgroundImage(sateItemInfo?.title)} />
			<PageTitle className="asics-bold">
				<animated.div style={titleMove}>
					<b>{sateItemInfo?.engTitle}</b>
				</animated.div>
			</PageTitle>
			{productList.length > 0 ? (
				<animated.div style={menuMove1}>
					<HorizontalScroll
						className={
							productList.filter((item) => item.pdbkProductId === undefined).length > 4
								? 'flexStart'
								: ''
						}
					>
						{productList
							.filter((item) => item.pdbkProductId === undefined)
							.map((item, index) => (
								<li key={index}>
									<button
										type="button"
										onClick={() => onTouchEnd(item)}
									>
										<img
											src={`https://app-spot2.co.kr:2406/api/file/view/id/${item.fileId}`}
											alt=""
										/>
									</button>
								</li>
							))}
					</HorizontalScroll>
				</animated.div>
			) : (
				<div className="noData">제품이 없습니다.</div>
			)}
			<NavigateButtonCps />
		</Container>
	)
}

export default CpsList2026
